/**
 * Detects if the current device is iOS (iPhone, iPad, iPod)
 * Handles modern iPad Safari which uses desktop user agent since iOS 13
 * @returns boolean indicating if the device is iOS
 */
export const isIOS = (): boolean => {
  const ua = navigator.userAgent

  // Legacy iOS detection (iPhone, iPod, older iPads)
  if (/iP(hone|od|ad)/.test(ua)) {
    return true
  }

  // Modern iPad detection (iOS 13+ iPads identify as Mac)
  // Check for Mac + touch support
  if (/Macintosh/.test(ua) && 'ontouchend' in document) {
    return true
  }

  return false
}

export default { isIOS }
